import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css";

const CustomSection = () => {
    return (
        <section className="custom-section text-center py-5">
            <div className="container"> <h2 className="fw-bold">
                Empowering Your Success with Human Expertise and Advanced Technology
            </h2>
            <p className="text-muted mt-3">
                Our team blends cutting-edge technology with a personalized approach to manage your accounting needs.
            </p>

            {/* Boxes */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-3 col-sm-6 mb-3">
                    <div className="custom-box">
                        A dedicated accountant backed by an expert team
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-3">
                    <div className="custom-box">
                        Bookkeepers who genuinely care about your business
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-3">
                    <div className="custom-box">
                        Friendly, responsive communication every step of the way
                    </div>
                </div>
            </div>
            </div>
            {/* Heading */}
           
        </section>
    );
};

export default CustomSection;